// import { EngineeringTwoTone } from "@mui/icons-material";
// import { TryRounded } from "@mui/icons-material";
import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory} from "react-router-dom";
import {Link} from "react-router-dom"
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";

const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  // const [username,setUsername]=useState("");
  // const [password,setPassword]=useState("");
  // const [confirmPassword,setConfirmPassword]=useState("");
  const [crcularProgress, setCrcularProgress] = useState(false);
  const navhistory = useHistory();
  const [formData, setFormData] = useState({
    username:"",
    password:"",
    confirmPassword:"",
  });

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async (formData) => {    
         try{
        setCrcularProgress(true);        
        let response=await axios.post(`${config.endpoint}/auth/register`,{
          username:formData.username,
          password:formData.password
        });
        if(response.status===201){
          setCrcularProgress(false);
        enqueueSnackbar("Register successfully",{variant:"success"})
        navhistory.push("/login");
        }
      }catch(err){
        setCrcularProgress(false);
        if(err.response && err.response.status===400){
        enqueueSnackbar(err.response.data.message,{variant:"error"});        
        }else{
          enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.",{variant:"error"});
        }    
  
      }
  };

  

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {
    const {username,password,confirmPassword}=data;

    if(!username){
      enqueueSnackbar("Username is a required field",{variant:"warning"}) 
      return false;
    }else if(username.length<6){
     enqueueSnackbar( "Username must be at least 6 characters",{variant:"warning"})
     return false;
    }else if(!password){
      enqueueSnackbar("Password is a required field",{variant:"warning"}) 
      return false;
    }else if(password.length<6){
      enqueueSnackbar("Password must be at least of 6 characters",{variant:"warning"})
      return false;
    }else if(password!==confirmPassword){
      enqueueSnackbar("Passwords do not match",{variant:"warning"})
      return false;
    }else{
      return true;
    }
  };


  const handleOnChange = (e)=> setFormData({...formData, [e.target.name]:e.target.value});
  const handleRegister = (event) => {
    event.preventDefault();
    if(validateInput(formData)){
      register(formData);
    }else {
      return;
    }
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            value={formData.username}
            name="username"
            placeholder="Enter Username"
            fullWidth
            onChange={handleOnChange}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            value={formData.password}
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            onChange={handleOnChange}
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            value={formData.confirmPassword}
            name="confirmPassword"
            type="password"
            fullWidth
            onChange={handleOnChange}
          />
          {crcularProgress?<Box sx={{display: "flex", justifyContent: "center"}}>
            <CircularProgress/></Box>:
          <Button className="button" variant="contained" onClick={handleRegister}>
          Register Now
         </Button>
          }
           
          <p className="secondary-action">
            Already have an account?{" "}
            
             <Link className={'link'} to="/login">
              Login here
            </Link>           
            
          </p>
          
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
